/**
*
*   i18n
*       - International Locale Messages Middleware
*
**/
'use client';

import Config from '@/config';
import { NextIntlClientProvider } from 'next-intl';


export default function LanguageProvider({ messages, locale , children , now , timeZone }){
  return (
	<NextIntlClientProvider
	locale={ locale || 'en' }
	messages={ messages }
	defaultTranslationValues={ Config.i18n.html }
	timeZone={ Config.i18n.timeZone }
	>
	{children}
	</NextIntlClientProvider>
  );
}